import { useEffect } from "react";
import { message } from "antd";
import { IMessage } from "../ui-kit";

import Constants from "../constants/Common";

interface StatusMessageInterface {
  status: string;
  details?: Record<string, Array<string>> | Array<string>;
  resetStatus: () => void;
}

export const useStatusMessage = ({
  status,
  details = null,
  resetStatus,
}: StatusMessageInterface) => {
  message.config({
    maxCount: 1,
  });

  useEffect(() => {
    if (status) {
      const value = (
        <IMessage
          title={
            Constants.statusMessage[status]
              ? Constants.statusMessage[status]
              : status
          }
          details={details}
        />
      );
      const config = {
        content: value,
        duration: Constants.messageDuration,
      };

      Constants.requestStatuses["error"] === status
        ? message.error(config)
        : message.success(config);

      if (resetStatus) resetStatus();
    }
  }, [status]);
};
